<script setup lang="ts">
defineProps<{
  label?: string
  name: string
  required?: boolean
}>()
</script>

<template>
  <div class="flex flex-col gap-2 font-mono text-sm uppercase">
    <label :for="name">
      <span>{{ label }} ({{ required ? 'Required' : 'Optional' }})</span>
    </label>

    <textarea
      :id="name"
      :required="required"
      :name="name"
      class="selection:!text-neon-yellow min-h-[5lh] resize-none border border-black/50 p-3 selection:!bg-black"
    />
  </div>
</template>
